/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { QUESTION, SURVEY } from './terminology';
import { SurveyUserRoles } from '@constants/user';

export interface Role {
    code: string,
    name: string,
    shortName: string,
    icon: string,
    subtitle?: string,
    description?: string,
}

interface Roles {
    [key: string]: Role;
}

export const roles: Roles = {
    [SurveyUserRoles.Admin]: {
        code: SurveyUserRoles.Admin,
        name: `Report ${SURVEY.CAPITALIZED_SINGULAR} Admin`,
        shortName: 'Administrator',
        subtitle: '',
        icon: 'fas fa-user-cog mr-2 text-ThemeTextWhite background-ThemeHeadingLight',
        description: `An Admin is someone who has been delegated by the Company to ensure that the correct ${SURVEY.CAPITALIZED_SINGULAR} Contributors, ${SURVEY.CAPITALIZED_SINGULAR} Monitors and ${SURVEY.CAPITALIZED_SINGULAR} Verifiers have been chosen to complete the ${SURVEY.SINGULAR}. The ${SURVEY.CAPITALIZED_SINGULAR} Admin can chose, on behalf of the Company, to delegate more Contributors, Monitors and Verifiers if they deem it suitable for the appropriate ${SURVEY.SINGULAR} completion.`,
    },
    [SurveyUserRoles.Stakeholder]: {
        code: SurveyUserRoles.Stakeholder,
        name: `Report ${SURVEY.CAPITALIZED_SINGULAR} Contributor`,
        shortName: 'Contributor',
        subtitle: '',
        description: `A ${SURVEY.CAPITALIZED_SINGULAR} Contributor is someone that has been delegated by the Admin, on behalf of the Company, to enter data into either a whole ${SURVEY.SINGULAR} or certain ${QUESTION.PLURAL} that they have been assigned. A contributor can be someone from any part of the Company's value chain. Contributors can only enter data and can only verify it if they have been delegated as a verifier as well.`,
        icon: 'fas fa-user-edit mr-2 text-ThemeTextWhite background-ThemeAccentMedium',
    },
    [SurveyUserRoles.Monitor]: {
        code: SurveyUserRoles.Monitor,
        name: `Report ${SURVEY.CAPITALIZED_SINGULAR} Monitor`,
        shortName: 'Monitor',
        subtitle: '',
        icon: 'fas fa-user mr-2 text-ThemeTextWhite background-ThemeDisabled',
        description: `A ${SURVEY.CAPITALIZED_SINGULAR} Monitor is someone that has been delegated by the Admin, on behalf of the Company, to monitor the data that has been entered to ensure progress is being made in completing data entry.`,
    },
    [SurveyUserRoles.Verifier]: {
        code: SurveyUserRoles.Verifier,
        name: `Report ${SURVEY.CAPITALIZED_SINGULAR} Verifier`,
        shortName: 'Verifier',
        subtitle: '',
        description: `A ${SURVEY.CAPITALIZED_SINGULAR} Verifier is someone that has been delegated by the Admin, on behalf of the Company, to verify data that has been entered by contributors. A Verifier can be someone from any part of the Company's value chain. Verifiers can only verify data and can only enter data if they have been delegated as a contributor as well.`,
        icon: 'fas fa-user-check mr-2 text-ThemeTextWhite background-ThemeSuccessMedium',
    },
};
